import { AboutCorentinSection } from '@/components/contact/AboutCorentinSection';
import { ContactFormSection } from '@/components/contact/ContactFormSection';
import { SEOHead } from '@/components/SEO/SEOHead';
import { useTranslation } from 'react-i18next';

export function ContactPage() {
  const { t } = useTranslation('contact');

  return (
    <div>
      <SEOHead
        title={t('seo.title', 'Contact - Aspexit')}
        description={t('seo.description', 'Contactez Aspexit pour vos projets en agriculture numerique')}
        path="/contact"
      />
      <AboutCorentinSection />
      <ContactFormSection />
    </div>
  );
}
